export default __webpack_public_path__ + "images/ddb4fe5a1f404e0a75da97094e2c3b9a.png";